import { render, staticRenderFns } from "./virtualListHead.vue?vue&type=template&id=2101f86c&scoped=true&"
import script from "./virtualListHead.vue?vue&type=script&setup=true&lang=ts&"
export * from "./virtualListHead.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./virtualListHead.vue?vue&type=style&index=0&id=2101f86c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2101f86c",
  null
  
)

export default component.exports